import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-document-readonly',
  templateUrl: 'field-document-readonly.component.html',
  styleUrls: ['../form-field-document.component.scss', 'field-document-readonly.component.scss']
})
export class FieldDocumentReadonlyComponent {
  @Input() field!: any;

  constructor() {
  }

  ngOnInit() {

  }

  get value() {
    return this.field.value?.data || [];
  }


}
